import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Checkbox.scss';

const Checkbox = ({ variantClasses = [], setup = {}, id, label, innerHTML, selected, inputChange, children, isError = false }) => {
	const inputChangeHandler = (e) => {
		const $checkbox = e.currentTarget;
		inputChange($checkbox.id, $checkbox.checked);
	};

	const labelAttributes = {};
	label = label || children || null;
	const checkboxClasses = [s.checkbox];
	if (isError === true) checkboxClasses.push(s.checkbox__error);
	if (innerHTML) labelAttributes.dangerouslySetInnerHTML = { __html: purifier(innerHTML, {}, setup) };

	if (!Array.isArray(variantClasses)) variantClasses = [variantClasses.toString()];
	variantClasses.filter((c) => !!c).forEach((c) => {
		checkboxClasses.push(s[c]);
	});

	return (
		<label key={id} htmlFor={id} className={checkboxClasses.join(' ')}>
			<input className={s.checkbox_input} id={id} type="checkbox" name={id} value="1" checked={selected === true} onChange={inputChangeHandler} />
			<span>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
					<g fill="none" fillRule="evenodd">
						<line x1=".5" x2="19.5" y1=".5" y2="19.5" stroke="#000" />
						<line x1="19.5" x2=".5" y1=".5" y2="19.5" stroke="#000" />
					</g>
				</svg>
			</span>
			<span className={s.checkbox_content} {...labelAttributes}>{ label }</span>
		</label>
	);
};

export default hot(module)(Checkbox);
